import React from 'react';
import Title from '../titles/Title';
import { Row,Col } from 'react-bootstrap';
import user1 from "../../assets/images/user_01.png";
import user2 from "../../assets/images/user_02.png";
import user3 from "../../assets/images/user_03.png";
import ReviewContainer from "../../components/reviewcontainer/ReviewContainer";

  // Static review/testimonial data
  const reviewData = [
    {
      image: user1,
      review:
        "I am using Livasa Shilajit from last 6 Months. I can see the Imapct of it on My Daily Routine and Sexual Power Both.",
      description: "Naresh Khanna - Age 44 - West Mumbai",
      ratings: "★★★★★",
    },
    {
      image: user2,
      review:
        "Me and my Husband are using the Livasa Kesar for last 3 months with Milk Every night for the better Health Being and Lifestyle.",
      description: "Narmata - Age - 32 - Delhi",
      ratings: "★★★★★",
    },
    {
      image: user3,
      review:
        "Livasa Jamun Honey and Neem Honey are the Best Switch over alternates for the Stage 1 and Stage 2 Diabetic Patient",
      description: "Amrit - Age 41 - Chandigarh",
      ratings: "★★★★☆",
    },
  ];
const ReviewSection = () => {
  return (
    <div className="section-container">
    <Title
      classname="text-center mb-5"
     /*  heading="What People Say About Us" */
    />
   {/*  <div className="container">
      <Row>
        {reviewData.map((e, index) => (
          <Col md={12} lg={4} key={index}>
            <ReviewContainer
              src={e.image}
              reviews={e.review}
              description={e.description}
              ratings={e.ratings}
            />
          </Col>
        ))}
      </Row>
    </div> */}
  </div>
  )
}

export default ReviewSection